module.exports = __webpack_public_path__ + "static/media/p19.7acbf6cf.png";